import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { RequisitionService } from '../services/requisition.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-list-requisition',
  templateUrl: './list-requisition.component.html',
  styleUrls: ['./list-requisition.component.css']
})
export class ListRequisitionComponent implements OnInit {

  loading: boolean;
  listContract: any;
  total: number;
  page: number;
  max: number;
  id: string;

  constructor(
    private dialog: MatDialog,
    private requisitionService: RequisitionService,
    private _router: Router,
    private route: ActivatedRoute,
  ) {
    if (route.snapshot.url[0].path == 'viewcontract')  {
      this.route.params.subscribe(params => {
        this.id = params['id'];
      });
    }

    this.loading = false;
    this.listContract = [];
    this.page = 1;
    this.max = 10;
  }

  ngOnInit() {
    this.refreshListing(1);
  }

  refreshListing(page) {
    this.loading = true;
    if (this.id) {
      this.requisitionService.getContractById(this.id)
      .subscribe(
        res => {
          this.loading = false;
          this.page = page;
          this.total = res.pagination.total;
          this.listContract = res.contracts;
        },
        () => {
          console.log('Error retrieving Requisitions');
          this.loading = false;
        }
      );
    } else {
      this.requisitionService.getContract(page)
      .subscribe(
        res => {
          this.loading = false;
          this.page = page;
          this.total = res.pagination.total;
          this.listContract = res.contracts;
        },
        () => {
          console.log('Error retrieving Requisitions');
          this.loading = false;
        }
      );
    }
  }

  gotoRequisition(requisition) {
    this._router.navigate(['/viewrequisition', requisition.id]);
  }

  putContractStatus(contract, status) {
    console.log('UpdateContractStatus' + contract + ' - ' + status);
    this.requisitionService.putContractStatus(contract.contract_id, status)
    .subscribe(
      res => {
        console.log('Change Status');
      },
      () => {
        console.log('Error retrieving Requisitions');
        this.loading = false;
      }
    );
  }

  putRequisitionStatus(requisition, status) {
    console.log('UpdateRequisitionStatus' + requisition + ' - ' + status);
    this.requisitionService.putRequisitionStatus(requisition.id, status)
    .subscribe(
      res => {
        console.log('Change Status');
      },
      () => {
        console.log('Error retrieving Requisitions');
        this.loading = false;
      }
    );
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data:
      {message: 'Listado de Requisiciones', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/list-requisition/list-requisition.component.ts